import { Client } from "@/Common/Api/Client";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { UserSettingsConfig } from "@/Common/Models/Settings/UserSettingsConfig";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { UserSettings } from "@/Globals/Models/UserSettings";

import styles from "./DocumentViewSettingPopup.module.scss";

interface IDocumentViewSettingPopupProps {
    onClose: () => void;
}

function DocumentViewSettingPopup(props: IDocumentViewSettingPopupProps): JSX.Element {
    const { getText } = useTranslation();

    const footer: JSX.Element = (
        <div className="p-footer">
            <div className="row">
                <div className="col-sm-12 columns text-right">
                    <ButtonControl
                        className="btn btn-default push-right-5"
                        onClick={() => saveDocumentViewSetting(false)}
                        label={getText("DocumentInAppViewMessagePopup_KeepCurrentViewLabel")}
                    />
                    <ButtonControl
                        className="btn btn-primary"
                        onClick={() => saveDocumentViewSetting(true)}
                        label={getText("DocumentInAppViewMessagePopup_TryNewViewLabel")}
                    />
                </div>
            </div>
        </div>
    );

    async function saveDocumentViewSetting(isDocumentInAppView: boolean): Promise<void> {
        const userSettings = new UserSettings({
            UserSettingsConfig: new UserSettingsConfig(cacheStore.UserSettings.UserSettingsConfig)
        });
        userSettings.UserSettingsConfig.ShowDocumentInAppView = isDocumentInAppView;

        const response = await Client.postAsync(
            ServerOperations.Server.Myle_UpdateUserSettings,
            {
                UserSettings: userSettings,
                UserId: sessionStore.userId
            }
        );

        if (!response.isSuccess) {
            sessionStore.showPopup(response.errors);
            return;
        }

        cacheStore.UserSettings.UserSettingsConfig = userSettings.UserSettingsConfig;

        props.onClose();
    }

    return (
        <Modal
            title={getText("DocumentInAppViewMessagePopup_Title")}
            width={600}
            top={50}
            footer={footer}
            showOverlay
            disableOverlayClose
        >
            <div>
                <p>{getText("DocumentInAppViewMessagePopup_NewWayToReviewDocuments")}</p>
                <ul className={styles.list}>
                    <li>{getText("DocumentInAppViewMessagePopup_HighlightAnnotateAndSign")}</li>
                    <li>{getText("DocumentInAppViewMessagePopup_FaxTheAnnotatedDocument")}</li>
                    <li>{getText("DocumentInAppViewMessagePopup_ConsultPatientMedicalHistory")}</li>
                </ul>
                <p>{getText("DocumentInAppViewMessagePopup_CanEasilyChangePreference")}</p>
            </div>
        </Modal>
    );
}

export { DocumentViewSettingPopup };
